var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#5EB5AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5249 68V45.1939H54.4855L55.6776 36.3051H46.5249V30.6301C46.5249 28.0558 47.2673 26.303 51.1054 26.303L56 26.3007V18.3501C55.1529 18.2426 52.2487 18 48.8675 18C41.8123 18 36.9808 22.1418 36.9808 29.7492V36.3039H29V45.1927H36.9808V67.9989H46.5261L46.5249 68Z",
    fill: "#F5F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f5e5954f06d3442e91e88b71a43d98cb.svg";
export { ForwardRef as ReactComponent };